export const PAGE_NAMES = {
  general: "Allgemein",
  content: "Inhalt",
  characteristics: "Ausprägungen",
  assets: "Ressourcen",
};
